import isUnknownObject from './isUnknownObject';
export default function isNode(object) {
  if ('Node' in window) {
    return object instanceof Node;
  } // Use duck typing for older browsers


  return isUnknownObject(object) && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
}
//# sourceMappingURL=isNode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/~/@flowio/browser-helpers/lib/esm/isNode.js
// module id = 675
// module chunks = 0 1